<template>
  <SendEmail
    :additional-props="additionalProps"
    :disabled="disabled"
    :value.sync="valueMutable"/>
</template>
<script>
import SendEmail from 'components/automation/actions/sendEmail.vue'

export default {
  name: 'sendEmailToActiveBids',
  computed: {
    valueMutable: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    },
  },
  components: {
    SendEmail
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
}
</script>
